import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/rental-property-cash-flow',
  component: () => import('../../routes/RentalPropertyCashFlow.svelte'),
  card: {
    id: 'rental-property-cash-flow',
    title: 'Rental Property Cash Flow',
    description: 'Calculate rental property NOI, cash flow, cap rate, and cash-on-cash return. Includes mortgage amortization and vacancy modeling.',
    icon: 'home_work',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/rental-property-cash-flow',
    category: 'Real Estate',
  },
  seo: {
    title: 'Rental Property Cash Flow Calculator – NOI, Cap Rate & Cash-on-Cash Return',
    description: 'Free rental property cash flow calculator to analyze investment real estate. Calculate Net Operating Income (NOI), cap rate, cash-on-cash return, and monthly mortgage payment with amortization schedule.',
  },
};

export default meta;
